import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { cloneElement, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
//redux
import { useDispatch } from 'react-redux';
// material-ui
import { useTheme } from '@mui/material/styles';
import {
    AppBar as MuiAppBar,
    Box,
    Button,
    Container,
    Drawer,
    IconButton,
    Link,
    List,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Stack,
    Toolbar,
    useScrollTrigger,
    InputBase,
    Grid,
    ClickAwayListener,
    Grow,
    Paper,
    Popper,
    MenuItem,
    MenuList,
    Collapse
} from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

// project imports
import Logo from 'ui-component/Logo';
import ProfileSection from 'layout/MainLayout/Header/ProfileSection';
// assets
import {
    IconUserCircle,
    IconServer2,
    Icon3dCubeSphere,
    IconBlockquote,
    IconDatabase,
    IconCloud,
    IconBrandPython,
    IconGitBranch,
    IconApi
} from '@tabler/icons-react';
import MenuIcon from '@mui/icons-material/Menu';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';

//Searchbar
const Search = styled('div')(({ theme }) => ({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    // backgroundColor: alpha(theme.palette.common.white, 0.15),
    // '&:hover': {
    //     backgroundColor: alpha(theme.palette.common.white, 0.25)
    // },
    marginLeft: 0,
    width: '98%',
    [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: '98%'
    }
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 999
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: '5px',
    '& .MuiInputBase-input': {
        padding: theme.spacing(1, 1, 1, 0),
        // background: '#fff',
        // vertical padding + font size from searchIcon
        paddingLeft: `calc(1em + ${theme.spacing(4)})`,
        transition: theme.transitions.create('width'),
        [theme.breakpoints.up('sm')]: {
            width: '100%',
            '&:focus': {
                width: '100%'
            }
        }
    }
}));

//Stack Item
const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: 'unset',
    ...theme.typography.body2,
    padding: theme.spacing(0),
    textAlign: 'center',
    color: theme.palette.text.secondary
}));

// elevation scroll
function ElevationScroll({ children, window }) {
    const theme = useTheme();
    const trigger = useScrollTrigger({
        disableHysteresis: true,
        threshold: 0,
        target: window
    });

    return cloneElement(children, {
        elevation: trigger ? 1 : 0,
        style: {
            backgroundColor: theme.palette.mode === 'dark' && trigger ? theme.palette.dark[800] : theme.palette.background.default,
            color: theme.palette.text.dark
        }
    });
}

ElevationScroll.propTypes = {
    children: PropTypes.node,
    window: PropTypes.object
};

// ==============================|| MINIMAL LAYOUT APP BAR ||============================== //

const AppBar = ({ onServiceClick, ...others }) => {
    const account = useSelector((state) => state.account);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [drawerToggle, setDrawerToggle] = useState(false);
    const theme = useTheme();
    const drawerToggler = (open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        setDrawerToggle(open);
    };
    //state
    const [openSolutionMenu, setOpenSolutionMenu] = React.useState(false);
    const [openAboutUsMenu, setOpenAboutUsMenu] = React.useState(false);
    const [openSearchBar, setOpenSearchBar] = React.useState(false);
    //anchor
    const anchorSolutionRef = React.useRef(null);
    const anchorAboutUsRef = React.useRef(null);
    const anchorAppbarRef = React.useRef(null);
    const anchorSearchRef = React.useRef(null);

    //handle toggle
    const handleToggleSolution = () => {
        setOpenSolutionMenu((prevSolutionMenuOpen) => !prevSolutionMenuOpen);
        // set OpenSearchBar equal false because anchorAppbarRef contains anchorSolutionRef
        setOpenSearchBar(false);
    };

    const handleToggleAboutUs = () => {
        setOpenAboutUsMenu((prevAboutUsMenuOpen) => !prevAboutUsMenuOpen);
        // set OpenSearchBar equal false because anchorAppbarRef contains anchorAboutUsRef
        setOpenSearchBar(false);
    };

    const handleToggleSearch = () => {
        setOpenSearchBar((prevSearchBarOpen) => !prevSearchBarOpen);
    };

    //Handle Close Menu
    const handleCloseSolutionMenu = (event) => {
        if (anchorSolutionRef.current && anchorSolutionRef.current.contains(event.target)) {
            return;
        }
        setOpenSolutionMenu(false);
    };

    const handleCloseAboutUsMenu = (event) => {
        if (anchorAboutUsRef.current && anchorAboutUsRef.current.contains(event.target)) {
            return;
        }

        setOpenAboutUsMenu(false);
    };

    const handleCloseSearchBar = (event) => {
        if (anchorAppbarRef.current && anchorAppbarRef.current.contains(event.target)) {
            return;
        }

        setOpenSearchBar(false);
    };

    function handleListKeyDown(event) {
        if (event.key === 'Tab') {
            event.preventDefault();
            setOpenSolutionMenu(false);
            setOpenAboutUsMenu(false);
            setOpenSearchBar(false);
        } else if (event.key === 'Escape') {
            setOpenSolutionMenu(false);
            setOpenAboutUsMenu(false);
            setOpenSearchBar(false);
        }
    }

    // return focus to the button when we transitioned from !open -> open
    const prevSolutionMenuOpen = React.useRef(openSolutionMenu);
    const prevAboutUsMenuOpen = React.useRef(openAboutUsMenu);
    const prevSearchBarOpen = React.useRef(openSearchBar);
    React.useEffect(() => {
        if (prevSolutionMenuOpen.current === true && openSolutionMenu === false) {
            anchorSolutionRef.current.focus();
        }
        if (prevAboutUsMenuOpen.current === true && openAboutUsMenu === false) {
            anchorAboutUsRef.current.focus();
        }
        if (prevSearchBarOpen.current === true && openSearchBar === false) {
            anchorSearchRef.current.focus();
        }

        prevSolutionMenuOpen.current = openSolutionMenu;
        prevAboutUsMenuOpen.current = openAboutUsMenu;
        prevSearchBarOpen.current = openSearchBar;
    }, [openSolutionMenu, openAboutUsMenu, openSearchBar]);

    //Mobile function
    const [openCollapseSolution, setOpenCollapseSolution] = React.useState(false);
    const [openCollapseAboutUs, setOpenCollapseAboutUs] = React.useState(false);
    const handleOpenCollapseSolution = () => {
        setOpenCollapseSolution(!openCollapseSolution);
    };
    const handleOpenCollapseAboutUs = () => {
        setOpenCollapseAboutUs(!openCollapseAboutUs);
    };
    useEffect(() => {
        if (drawerToggle === false) {
            setOpenCollapseSolution(false);
            setOpenCollapseAboutUs(false);
        }
    }, [drawerToggle]);

    //actions

    const handleSearchClick = () => {
        navigate('/pages/search-result');
    };

    return (
        <ElevationScroll {...others}>
            <MuiAppBar>
                <Grid container sx={{ backgroundColor: theme.palette.main.appbar }}>
                    <Container ref={anchorAppbarRef} onClick={handleCloseSearchBar}>
                        <Toolbar sx={{ py: 2.5, px: `0 !important` }}>
                            <Link href="/pages/homepage" sx={{ display: { xs: 'none', md: 'block' } }}>
                                <Logo />
                            </Link>
                            <Stack
                                direction="row"
                                sx={{
                                    display: { xs: 'none', md: 'block' },
                                    flexGrow: 1,
                                    textAlign: 'center',
                                    color: theme.palette.main.items
                                }}
                                spacing={{ xs: 1.5, md: 2.5 }}
                            >
                                <Button
                                    ref={anchorSolutionRef}
                                    id="solution-button"
                                    aria-controls={openSolutionMenu ? 'solution-menu' : undefined}
                                    aria-expanded={openSolutionMenu ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={handleToggleSolution}
                                    color="inherit"
                                    sx={{ fontWeight: 'bolder' }}
                                    endIcon={openSolutionMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                >
                                    SẢN PHẨM
                                </Button>
                                <Popper
                                    open={openSolutionMenu}
                                    anchorEl={anchorSolutionRef.current}
                                    role={undefined}
                                    placement="bottom-start"
                                    transition
                                    disablePortal
                                >
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{
                                                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom'
                                            }}
                                        >
                                            <Paper>
                                                <ClickAwayListener onClickAway={handleCloseSolutionMenu}>
                                                    <MenuList
                                                        autoFocusItem={openSolutionMenu}
                                                        id="solution-menu"
                                                        aria-labelledby="solution-button"
                                                        onKeyDown={handleListKeyDown}
                                                    >
                                                        <MenuItem onClick={handleCloseSolutionMenu}>
                                                            <ListItemIcon>
                                                                <IconCloud size={20} />
                                                            </ListItemIcon>
                                                            <ListItemText primary="Multi-Cloud Storage" secondary="S3, GCS, Azure, MinIO" />
                                                        </MenuItem>
                                                        <MenuItem onClick={handleCloseSolutionMenu}>
                                                            <ListItemIcon>
                                                                <IconBrandPython size={20} />
                                                            </ListItemIcon>
                                                            <ListItemText primary="JupyterHub" secondary="GPU-enabled computing" />
                                                        </MenuItem>
                                                        <MenuItem onClick={handleCloseSolutionMenu}>
                                                            <ListItemIcon>
                                                                <IconGitBranch size={20} />
                                                            </ListItemIcon>
                                                            <ListItemText primary="Apache Airflow" secondary="Workflow orchestration" />
                                                        </MenuItem>
                                                        <MenuItem onClick={handleCloseSolutionMenu}>
                                                            <ListItemIcon>
                                                                <IconDatabase size={20} />
                                                            </ListItemIcon>
                                                            <ListItemText primary="MongoDB" secondary="Document database" />
                                                        </MenuItem>
                                                        <MenuItem onClick={handleCloseSolutionMenu}>
                                                            <ListItemIcon>
                                                                <IconApi size={20} />
                                                            </ListItemIcon>
                                                            <ListItemText primary="API Platform" secondary="REST APIs & Webhooks" />
                                                        </MenuItem>
                                                        <MenuItem onClick={handleCloseSolutionMenu}>
                                                            <ListItemIcon>
                                                                <IconServer2 size={20} />
                                                            </ListItemIcon>
                                                            <ListItemText primary="API Gateway" secondary="Rate limiting & Security" />
                                                        </MenuItem>
                                                        <MenuItem
                                                            onClick={(event) => {
                                                                handleCloseSolutionMenu(event);
                                                                navigate('/workspace/storage');
                                                            }}
                                                        >
                                                            <ListItemIcon>
                                                                <Icon3dCubeSphere size={20} />
                                                            </ListItemIcon>
                                                            <ListItemText primary="Quản lý dự án" secondary="Workspace & Storage" />
                                                        </MenuItem>
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                                <Button color="inherit" sx={{ fontWeight: 'bolder' }} onClick={onServiceClick}>
                                    DỊCH VỤ
                                </Button>
                                <Button
                                    color="inherit"
                                    sx={{ fontWeight: 'bolder' }}
                                    component={Link}
                                    href="/documentation"
                                    target="_blank"
                                >
                                    TÀI LIỆU
                                </Button>
                                <Button
                                    ref={anchorAboutUsRef}
                                    id="about-us-button"
                                    aria-controls={openAboutUsMenu ? 'about-us-menu' : undefined}
                                    aria-expanded={openAboutUsMenu ? 'true' : undefined}
                                    aria-haspopup="true"
                                    onClick={handleToggleAboutUs}
                                    color="inherit"
                                    sx={{ fontWeight: 'bolder' }}
                                    endIcon={openAboutUsMenu ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                >
                                    VỀ CHÚNG TÔI
                                </Button>
                                <Popper
                                    open={openAboutUsMenu}
                                    anchorEl={anchorAboutUsRef.current}
                                    role={undefined}
                                    placement="bottom-start"
                                    transition
                                    disablePortal
                                >
                                    {({ TransitionProps, placement }) => (
                                        <Grow
                                            {...TransitionProps}
                                            style={{
                                                transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom'
                                            }}
                                        >
                                            <Paper>
                                                <ClickAwayListener onClickAway={handleCloseAboutUsMenu}>
                                                    <MenuList
                                                        autoFocusItem={openAboutUsMenu}
                                                        id="about-us-menu"
                                                        aria-labelledby="about-us-button"
                                                        onKeyDown={handleListKeyDown}
                                                    >
                                                        <MenuItem onClick={handleCloseAboutUsMenu}>
                                                            <RouterLink component={Link} to="#" target="_blank">
                                                                Về chúng tôi
                                                            </RouterLink>
                                                        </MenuItem>
                                                        <MenuItem onClick={handleCloseAboutUsMenu}>
                                                            <RouterLink component={Link} to="#" target="_blank">
                                                                Tin tức
                                                            </RouterLink>
                                                        </MenuItem>
                                                        <MenuItem onClick={handleCloseAboutUsMenu}>
                                                            <RouterLink component={Link} to="/pages/term-of-use" target="_blank">
                                                                Điều khoản sử dụng
                                                            </RouterLink>
                                                        </MenuItem>
                                                        <MenuItem onClick={handleCloseAboutUsMenu}>
                                                            <RouterLink component={Link} to="/pages/privacy-policy" target="_blank">
                                                                Chính sách bảo mật
                                                            </RouterLink>
                                                        </MenuItem>
                                                    </MenuList>
                                                </ClickAwayListener>
                                            </Paper>
                                        </Grow>
                                    )}
                                </Popper>
                            </Stack>
                            <Stack
                                direction="row"
                                sx={{ display: { xs: 'none', md: 'flex', alignItems: 'center' } }}
                                spacing={{ xs: 1, md: 2 }}
                            >
                                {!account.isLoggedIn && (
                                    <Item sx={{ color: theme.palette.main.items }}>
                                        <Button
                                            component={RouterLink}
                                            to="/login"
                                            disableElevation
                                            variant="outlined"
                                            sx={{ color: theme.palette.main.items, marginRight: 1 }}
                                        >
                                            Đăng nhập
                                        </Button>
                                        <Button
                                            disableElevation
                                            variant="contained"
                                            sx={{
                                                backgroundColor: theme.palette.main.items
                                            }}
                                        >
                                            <RouterLink component={Link} to="/register">
                                                Đăng ký
                                            </RouterLink>
                                        </Button>
                                    </Item>
                                )}
                                {account.isLoggedIn && <ProfileSection />}
                            </Stack>
                            <Stack
                                direction="row"
                                spacing={1}
                                sx={{
                                    display: { xs: 'flex', sm: 'flex', md: 'none' },
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    width: '100%'
                                }}
                            >
                                <Item>
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        sx={{
                                            display: { xs: 'flex', sm: 'flex', md: 'none' },
                                            alignItems: 'center'
                                        }}
                                    >
                                        <IconButton
                                            color="inherit"
                                            onClick={drawerToggler(true)}
                                            size="large"
                                            sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }}
                                        >
                                            <MenuIcon />
                                        </IconButton>
                                        <Link href="/pages/homepage" sx={{ display: { xs: 'flex', sm: 'flex', md: 'none' } }}>
                                            <Logo />
                                        </Link>
                                    </Stack>
                                </Item>
                                <Item>
                                    <Stack
                                        direction="row"
                                        sx={{ display: { xs: 'flex', sm: 'flex', md: 'none', alignItems: 'center' } }}
                                        spacing={{ xs: 1, md: 2 }}
                                    >
                                        {!account.isLoggedIn && (
                                            <Item sx={{ color: theme.palette.main.items }}>
                                                <Button
                                                    component={RouterLink}
                                                    to="/login"
                                                    disableElevation
                                                    variant="outlined"
                                                    sx={{ color: theme.palette.main.items, marginRight: 1 }}
                                                >
                                                    Đăng nhập
                                                </Button>
                                                <Button
                                                    disableElevation
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: theme.palette.main.items
                                                    }}
                                                >
                                                    <RouterLink component={Link} to="/register">
                                                        Đăng ký
                                                    </RouterLink>
                                                </Button>
                                            </Item>
                                        )}
                                        {account.isLoggedIn && <ProfileSection />}
                                    </Stack>
                                </Item>
                            </Stack>

                            <Drawer anchor="top" open={drawerToggle} onClose={drawerToggler(false)}>
                                {drawerToggle && (
                                    <Box
                                        sx={{ width: 'auto' }}
                                        role="presentation"
                                        // onClick={drawerToggler(false)}
                                        // onKeyDown={drawerToggler(false)}
                                    >
                                        <List>
                                            <Link style={{ textDecoration: 'none' }}>
                                                <ListItemButton onClick={handleOpenCollapseSolution}>
                                                    <ListItemIcon color={theme.palette.main.items}>
                                                        <Icon3dCubeSphere />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Sản phẩm" />
                                                    {openCollapseSolution ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                </ListItemButton>
                                            </Link>
                                            <Collapse in={openCollapseSolution} timeout="auto" unmountOnExit>
                                                <List component="div" disablePadding>
                                                    <ListItemButton
                                                        onClick={drawerToggler(false)}
                                                        style={{ paddingLeft: theme.spacing(4) }}
                                                    >
                                                        <ListItemIcon>
                                                            <IconCloud size={16} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Multi-Cloud Storage" />
                                                    </ListItemButton>
                                                    <ListItemButton
                                                        onClick={drawerToggler(false)}
                                                        style={{ paddingLeft: theme.spacing(4) }}
                                                    >
                                                        <ListItemIcon>
                                                            <IconBrandPython size={16} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="JupyterHub" />
                                                    </ListItemButton>
                                                    <ListItemButton
                                                        onClick={drawerToggler(false)}
                                                        style={{ paddingLeft: theme.spacing(4) }}
                                                    >
                                                        <ListItemIcon>
                                                            <IconGitBranch size={16} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Apache Airflow" />
                                                    </ListItemButton>
                                                    <ListItemButton
                                                        onClick={drawerToggler(false)}
                                                        style={{ paddingLeft: theme.spacing(4) }}
                                                    >
                                                        <ListItemIcon>
                                                            <IconDatabase size={16} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="MongoDB" />
                                                    </ListItemButton>
                                                    <ListItemButton
                                                        onClick={drawerToggler(false)}
                                                        style={{ paddingLeft: theme.spacing(4) }}
                                                    >
                                                        <ListItemIcon>
                                                            <IconApi size={16} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="API Platform" />
                                                    </ListItemButton>
                                                    <ListItemButton
                                                        onClick={drawerToggler(false)}
                                                        style={{ paddingLeft: theme.spacing(4) }}
                                                    >
                                                        <ListItemIcon>
                                                            <IconServer2 size={16} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="API Gateway" />
                                                    </ListItemButton>
                                                    <ListItemButton
                                                        onClick={() => {
                                                            setDrawerToggle(false);
                                                            navigate('/workspace/storage');
                                                        }}
                                                        style={{ paddingLeft: theme.spacing(4) }}
                                                    >
                                                        <ListItemIcon>
                                                            <Icon3dCubeSphere size={16} />
                                                        </ListItemIcon>
                                                        <ListItemText primary="Quản lý dự án" />
                                                    </ListItemButton>
                                                </List>
                                            </Collapse>
                                            <Link style={{ textDecoration: 'none' }} href="/login" target="_blank">
                                                <ListItemButton onClick={drawerToggler(false)}>
                                                    <ListItemIcon color={theme.palette.main.items}>
                                                        <IconServer2 />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Dịch vụ" />
                                                </ListItemButton>
                                            </Link>
                                            <Link style={{ textDecoration: 'none' }} href="/documentation" target="_blank">
                                                <ListItemButton onClick={drawerToggler(false)}>
                                                    <ListItemIcon color={theme.palette.main.items}>
                                                        <IconBlockquote />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Tài liệu" />
                                                </ListItemButton>
                                            </Link>
                                            <Link style={{ textDecoration: 'none' }}>
                                                <ListItemButton onClick={handleOpenCollapseAboutUs}>
                                                    <ListItemIcon color={theme.palette.main.items}>
                                                        <IconUserCircle />
                                                    </ListItemIcon>
                                                    <ListItemText primary="Về chúng tôi" />
                                                    {openCollapseAboutUs ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                </ListItemButton>
                                                <Collapse in={openCollapseAboutUs} timeout="auto" unmountOnExit>
                                                    <List component="div" disablePadding>
                                                        <ListItemButton
                                                            onClick={drawerToggler(false)}
                                                            style={{ paddingLeft: theme.spacing(4) }}
                                                        >
                                                            <ListItemText primary="Về chúng tôi" />
                                                        </ListItemButton>
                                                        <ListItemButton
                                                            onClick={drawerToggler(false)}
                                                            style={{ paddingLeft: theme.spacing(4) }}
                                                        >
                                                            <ListItemText primary="Tin tức" />
                                                        </ListItemButton>
                                                        <ListItemButton
                                                            onClick={drawerToggler(false)}
                                                            style={{ paddingLeft: theme.spacing(4) }}
                                                        >
                                                            <ListItemText primary="Điều khoản sử dụng" />
                                                        </ListItemButton>
                                                        <ListItemButton
                                                            onClick={drawerToggler(false)}
                                                            style={{ paddingLeft: theme.spacing(4) }}
                                                        >
                                                            <ListItemText primary="Chính sách bảo mật" />
                                                        </ListItemButton>
                                                    </List>
                                                </Collapse>
                                            </Link>
                                        </List>
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            sx={{ display: 'flex', justifyContent: 'right', padding: '20px 10px 5px 5px' }}
                                        >
                                            <Item sx={{ color: theme.palette.main.items }}>
                                                <Button
                                                    component={Link}
                                                    href="/login"
                                                    disableElevation
                                                    variant="outlined"
                                                    sx={{ color: theme.palette.main.items }}
                                                >
                                                    Đăng nhập
                                                </Button>
                                            </Item>
                                            <Item>
                                                <Button
                                                    disableElevation
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: theme.palette.main.items
                                                    }}
                                                >
                                                    <RouterLink component={Link} to="/register">
                                                        Đăng ký
                                                    </RouterLink>
                                                </Button>
                                            </Item>
                                        </Stack>
                                    </Box>
                                )}
                            </Drawer>
                        </Toolbar>
                    </Container>
                </Grid>
            </MuiAppBar>
        </ElevationScroll>
    );
};

export default AppBar;
